import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private permissions: string[] = [];

  constructor() {
    const data = localStorage.getItem('permisos');
    this.permissions = data ? JSON.parse(data) : [];
  }

  has(permission: string): boolean {
    return this.permissions.includes(permission);
  }

  hasAny(perms: string[]): boolean {
    return perms.some(p => this.has(p));
  }

  setPermissions(perms: string[]) {
    this.permissions = perms;
    localStorage.setItem('permissions', JSON.stringify(perms));
  }
  
}
